import React from 'react';
import { arrayOf, bool, func, shape } from 'prop-types';
import AddressTile from 'components/Address/common/AddressTile';
import { schema as addressSchema } from 'components/Address/util';
import styles from './MappedAddressRows.scss';

const mappedAddressRowsDefaultPropOnAfterSelect = () => {};

const MappedAddressRows = ({
  addresses,
  onAfterSelect = mappedAddressRowsDefaultPropOnAfterSelect,
  isEditable = false,
  selectable = false,
  canSelectContactAddress = false,
  deletable = true,
}) => {
  return (
    <div className={styles.addressListWrapper}>
      <ul className={styles.addressList}>
        {addresses &&
          addresses.length > 0 &&
          addresses.map((address, index) => (
            <li
              className={styles.listItem}
              key={`${address.id}`}
              data-testid={`mapped-address-item-${index}`}
            >
              <AddressTile
                address={address}
                isEditable={isEditable}
                onAfterSelect={onAfterSelect}
                selectable={!!selectable}
                deletable={deletable}
                canSelectContactAddress={canSelectContactAddress}
              />
            </li>
          ))}
      </ul>
    </div>
  );
};

MappedAddressRows.propTypes = {
  addresses: arrayOf(shape(addressSchema)).isRequired,
  isEditable: bool,
  onAfterSelect: func,
  selectable: bool,
  canSelectContactAddress: bool,
  deletable: bool,
};

export default MappedAddressRows;
